module.exports = __webpack_public_path__ + "img/4.377d8bab.jpg";